import { AdmiralCardWarning } from '../AdmiralCardWarning';
import * as React from 'react';

export const ToManyAttempts = () => {

  const body = 'Sorry, you have attempted too many quotes in a short amount of time! Please try again shortly.';

  return (
    <div style={{ maxWidth: '600px', margin: 'auto', height: '100vh' }}>
      <AdmiralCardWarning icon={'warning.svg'} title={'No Quotes are available'}>
        {body}
      </AdmiralCardWarning>
    </div>
  )


}
